import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PatientList from './PatientList'
import SearchForm from './SearchForm'
import './PatientSelector.css'
import {patientActions} from '../../../../redux/patient'
import { bindActionCreators } from 'redux'
import connect from 'react-redux/es/connect/connect'

class PatientSelector extends Component {
  constructor (props) {
    super(props)
    this.state = {
      formColor: '',
      input: '',
      searchRecents: true,
      patientsList: props.recentPatients || []
    }
    this.searchRecents = this.searchRecents.bind(this)
    this.searchHealthID = this.searchHealthID.bind(this)
  }

  componentDidUpdate (prevProps) {
    if (this.props.recentPatients !== prevProps.recentPatients) {
      this.searchRecents()
    }
  }

  searchRecents (value = '') {
    let patientsList = this.props.recentPatients
    if (value.length > this.props.numChars) {
      patientsList = patientsList.filter(val => val.name.search(value) !== -1)
    }
    this.setState({patientsList})
  }

  searchHealthID (value) {
    if (this.props.searchID) {
      this.props.searchID(value)
    }
  }

  render () {
    const {patientsList} = this.state
    return (
      <div className='patient-search uk-container uk-container-xsmall uk-margin-auto'>
        <SearchForm searchRecents={this.searchRecents} searchID={this.searchHealthID} />
        <PatientList
          selectPatient={this.props.selectPatient}
          className='uk-grid'
          patients={patientsList}
          match={this.props.match}
        />
      </div>
    )
  }

  static defaultProps = {
    numChars: 2
  }

  static propTypes = {
    match: PropTypes.object.isRequired,
    recentPatients: PropTypes.arrayOf(PropTypes.object).isRequired,
    searchID: PropTypes.func,
    numChars: PropTypes.number.isRequired
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({...patientActions}, dispatch)
}

export default connect(undefined, mapDispatchToProps)(PatientSelector)
